<template>
  <div class="no-result flex-ccc" :style="bodyStyle">
      <div class="no-result-img" :class="type"></div>
      <div>{{text || '暂无数据'}}</div>
    </div>
</template>

<script>
  export default {
    name: 'noData',
    props: [ 'text', 'type', 'bodyStyle' ]
  }
</script>
<style  scoped lang="stylus">
  .no-result
    height 165px
    .no-result-img
      width 93px
      height 88px
      background: url("../../assets/images/noData-coupon.png")
      background-size: 93px 88px
      background-position center
      margin 20px
</style>
